import { render, staticRenderFns } from "./SubmerchantTerminalsList.vue?vue&type=template&id=924db448&"
import script from "./SubmerchantTerminalsList.vue?vue&type=script&lang=js&"
export * from "./SubmerchantTerminalsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports